import { ILecturerItem } from './Lecturer';

export interface IRecordItem {
    course: {
        _key: string;
        title: string;
        slug: string;
    };
    lectors: ILecturerItem[];
    tags: {
        title: string;
        color: string;
    }[];
    modules: {
        name: string;
        _key: string;
    }[];
    video: {
        duration: string;
        _key: string;
        frame: string;
    };
}

export interface IRecordItem {
    course: {
        _key: string;
        title: string;
        slug: string;
    };
    lectors: ILecturerItem[];
    tags: {
        title: string;
        color: string;
    }[];
    modules: {
        name: string;
        _key: string;
    }[];
    video: {
        duration: string;
        _key: string;
        frame: string;
    };
}

export interface IAcademyItem {
    module: {
        annotation: string;
        program: string;
        name: string;
        slug: string;
        price: number;
        price_with_vat: number;
        _key: string;
        methodsSale: IMethodsSaleItem[];
        eso9: {
            stock_card: string;
        };
    };
    tags: {
        color: string;
        title: string;
    }[];
    events: ITrainingItem[];
    online: boolean;
    presence: boolean;
    date_from: Date;
    date_to: Date;
}

export interface IAcademyItem2 {
    modules?: {
        date_from: Date;
        date_to: Date;
        events: ITrainingItem[];
        module: {
            annotation: string;
            program: string;
            name: string;
            slug: string;
            price: number;
            price_with_vat: number;
            _key: string;
            methodsSale: IMethodsSaleItem[];
            eso9: {
                stock_card: string;
            };
        };
    }[];
    module: {
        annotation: string;
        program: string;
        name: string;
        slug: string;
        price: number;
        price_with_vat: number;
        _key: string;
        methodsSale: IMethodsSaleItem[];
        eso9: {
            stock_card: string;
        };
    };
    tags: {
        color: string;
        title: string;
    }[];
    academy: {
        slug: string;
        title: string;
        annotation?: string;
        program?: string;
        methodsSale: IMethodsSaleItem[];
        seo?: {
            description?: string;
            keywords?: string;
            title?: string;
        };
    };
    
    online: boolean;
    presence: boolean;
    date_from: Date;
    date_to: Date;
}

export interface ITrainingItem {
    attachments: {
        _key: string;
        name: string;
        filename: string;
        mime_type: string;
    }[];
    conference?: {
        _id: string;
        _key: string;
        title: string;
        slug: string;
    };
    event?: {
        _id: string;
        _key: string;
        title: string;
        slug: string;
    };
    course?: {
        _id: string;
        _key: string;
        custom: { company: string };
        title: string;
        state: number;
        slug: string;
        seo: {
            description: string;
            keywords: string;
            title: string;
        };
        program: string;
        instructions: string;
        detail: string;
        experience_description: string;
        static_gallery: string[];
        created_at: Date;
        bonuses: string;
        benefits: string;
        annotation: string;
        published: {
            from: Date;
            to: Date;
        };
        schedule: {
            title: string;
            description: string;
            part: {
                description: string;
                from: Date;
                to: Date;
            }[];
        }[];
        video_invitations: {
            url: string;
        }[];
    };
    isFavorite: boolean;
    is_favourite: boolean;
    is_favorite: boolean;
    eventDates?: ITrainingItemDate[];
    eventDate?: ITrainingItemDate;
    dates?: ITrainingItemDate[];
    presence?: boolean;
    online?: boolean;
    lecturers: {
        person: ILecturerItem;
        upcoming: IUpcomingEvent[];
    }[];
    modules: IModuleItem[];
    tags: { title: string; label: boolean; color: string }[];
}

export interface IModuleItem {
    accessible: boolean;
    module: {
        name: string;
        _key: string;
        price_with_vat: number;
        price: number;
    };
}
export interface IModule {
    name: string;
    _key: string;
    price_with_vat: number;
    price: number;
}

export interface IMethodsSaleItem {
    name?: string;
    description?: string;
    url?: string;
    priceVat?: number;
    priceWithoutVat?: number;
    color?: string;
};

export interface IUpcomingEvent {
    course: {
        title: string;
    };
    dates: {
        from: Date;
        to: Date;
    };
    venues: {
        city: string;
        name: string;
        street: string;
    }[];
}

export interface ITrainingItemDate {
    accessible: boolean;
    online: boolean;
    isOnline: boolean;
    attachments: {
        name: string;
        _key: string;
    }[];
    date: {
        _key: string;
        from: string;
        to: string;
        state: number;
        visibilityState: number;
    };
    streams: {
        _key: string;
        url: string;
    }[];
    videos: {
        _key: string;
        duration: number;
        timeWatched: number;
        chapters: {
            time: number;
            title: string;
        }[];
        name: string;
        url: string;
        created_at: Date;
    }[];
    venues: {
        city: string;
        name: string;
        _key: string;
        _id: string;
        street: string;
        link: string;
    }[];
    modules: {
        _key: string;
        price: number;
        price_with_vat: number;
        eso9: {
            stock_card: string;
        };
    }[];
    lectors?: ILecturerItem[];
    people?: ILecturerItem[];
    tags: { title: string; label: boolean; color: string }[];
}

export interface IVideoInvitation {
    url: string;
}

export enum EventStates {
    NO_VISIBLE = 0,
    VISIBLE = 1,
}

export enum EventDateState {
    AVAILABLE = 0,
    SOLD_OUT = 1,
    CANCELLED = 2,
}

export enum EventTypes {
    TRAINING = '0',
    CONFERENCE = '1',
    ARCHIVE = '2',
}

export enum BannerTypes {
    DESKTOP = 'desktop',
    TABLET = 'tablet',
    MOBILE = 'mobile',
}

export enum FilterViewTypes {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
}

export enum TrainingViewTypes {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
}

export enum NotificationCategory {
    notice = 'notice',
    futureCourse = 'futureCourse',
    recording = 'recording',
    recommendation = 'recommendation',
    futureCourseReminder = 'futureCourseReminder',
    recordingReminder = 'recordingReminder',
}
